import React, { useState, useEffect } from "react"
import {
  Box,
  Button,
  Flex,
  Stack,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  useTheme,
} from "@chakra-ui/react"
import OrdersDashboard from "./OrdersDashboard"
import OrdersUpload from "./OrdersUpload"
import StoreComments from "./StoreComments"

const Orders = () => {
  const [activeTab, setActiveTab] = useState("dashboard")
  const [isAdmin, setIsAdmin] = useState(false)
  const [latestUploadId, setLatestUploadId] = useState(null)
  const theme = useTheme()

  useEffect(() => {
    const userid = localStorage.getItem("userid")
    if (userid === "1" || userid === "2") {
      setIsAdmin(true)
    }
  }, [])

  const handleUploadComplete = (upload_id) => {
    setLatestUploadId(upload_id)
    setActiveTab("dashboard")
  }

  if (!isAdmin) {
    return (
      <Box minH="100vh" p={4}>
        <Alert status="error" borderRadius="lg">
          <AlertIcon />
          <AlertTitle>Access Denied</AlertTitle>
          <AlertDescription>This page is available to administrators only.</AlertDescription>
        </Alert>
      </Box>
    )
  }

  const renderComponent = () => {
    switch (activeTab) {
      case "dashboard":
        return <OrdersDashboard latestUploadId={latestUploadId} />
      case "upload":
        return <OrdersUpload onUploadComplete={handleUploadComplete} />
      case "comments":
        return <StoreComments />
      default:
        return null
    }
  }

  return (
    <Box mt={16}>
      <Flex justify="center" mb={4}>
        <Stack direction="row" spacing={4}>
          <Button
            onClick={() => setActiveTab("dashboard")}
            variant={activeTab === "dashboard" ? "solid" : "outline"}
            borderColor={activeTab === "dashboard" ? theme.colors.primary1 : "transparent"}
            borderWidth="2px"
          >
            Dashboard
          </Button>
          <Button
            onClick={() => setActiveTab("upload")}
            variant={activeTab === "upload" ? "solid" : "outline"}
            borderColor={activeTab === "upload" ? theme.colors.primary1 : "transparent"}
            borderWidth="2px"
          >
            Upload
          </Button>
          <Button
            onClick={() => setActiveTab("comments")}
            variant={activeTab === "comments" ? "solid" : "outline"}
            borderColor={activeTab === "comments" ? theme.colors.primary1 : "transparent"}
            borderWidth="2px"
          >
            Store Comments
          </Button>
        </Stack>
      </Flex>
      <Box px={4}>{renderComponent()}</Box>
    </Box>
  )
}

export default Orders
